<template>
    <div></div>
</template>
  
<script>

import { STORE_CONSTANTS } from "../common/store.constants";
export default {
  name: "DailyTasksInfo",
  props: {
  },
  data: () => ({
    STORE_CONSTANTS,
    chartData: null,
    routeData: null
  }),
  created () {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if(mutation.type === this.STORE_CONSTANTS.TRACKS.MUTATIONS.WITH_NAMESPACE.SET_TASKS_FEATURES) {
        this.$store.dispatch(this.STORE_CONSTANTS.DAILY_TASKS.ACTIONS.WITH_NAMESPACE.SET_STAFF_DAILY_TASKS, 
          { features: state.tracks.taskFeatures, criteria: criteria }).then((resp) => {
            this.prepareChartData(state.tracks.taskFeatures);
            this.routeData = state.validation.taskFeatures;
          });
      }
    });
  },
  beforeDestroy() {
    if(this.unsubscribe) {
        this.unsubscribe();
    }
  },
  methods: {
    prepareChartData(data) {

        if(data) {
            let suspectTaskCount;
            let validTaskCount;
            let underReviewTaskCount;
            let completedTaskCount;
            let unKnownTaskCount;
            let falsifiedTaskCount;
            let noDataTaskCount;
            let upDatedTaskCount;

            console.log('CreateStatusSummaryChart this.allTasks', data)

            suspectTaskCount = data.filter((feature) => {
                return feature.Status === "SUSPECT";
            }).length;

            validTaskCount = data.filter((feature) => {
                return feature.Status === "VALID";
            }).length;

            underReviewTaskCount = data.filter((feature) => {
                return feature.Status === "UNDER_REVIEW";
            }).length;

            completedTaskCount = data.filter((feature) => {
                return feature.Status === "COMPLETED";
            }).length;

            unKnownTaskCount = data.filter((feature) => {
                return feature.Status === "UNKNOWN";
            }).length;

            falsifiedTaskCount = data.filter((feature) => {
                return feature.Status === "FALSIFIED";
            }).length;

            noDataTaskCount = data.filter((feature) => {
                return feature.Status === "NO_DATA";
            }).length;

            upDatedTaskCount = data.filter((feature) => {
                return feature.Status === "UPDATED";
            }).length;

            let chartData = [
                ["COMPLETED", completedTaskCount],
                ["SUSPECT", suspectTaskCount],
                ["VALID", validTaskCount],
                ["UNKNOWN", unKnownTaskCount],
                ["UNDER REVIEW", underReviewTaskCount],
                ["FALSIFIED", falsifiedTaskCount],
                ["NO DATA", noDataTaskCount],
                ["UPDATED", upDatedTaskCount]
            ];

            Vue.set(this, 'chartData', chartData);
        }

    }
  }
};
</script>

<style scoped>
</style>